export const avatarSizes = {
  small: "w-8 h-8",
  medium: "w-[8rem] h-[8rem]",
  smallMedium: "w-[5rem] h-[5rem]",
  full: "w-full h-full",
};

export type AvatarSize = keyof typeof avatarSizes;
